import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import GeneralTypeValue from '../../entities/preferences/generaltypevalue'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'
import GeneralType from '@/store/entities/preferences/generaltype';

interface GeneralTypeValueState extends ListState<GeneralTypeValue>{
    editModel:GeneralTypeValue;
    gtype: number;
    
}
class GeneralTypeValueModule extends ListModule<GeneralTypeValueState,any,GeneralTypeValue>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<GeneralTypeValue>(),
        loading:false,
        gtype:null,
        editModel: new GeneralTypeValue()
    }
    actions = {
        async getAll(context: ActionContext<GeneralTypeValueState, any>, payload: any) {
            //context.state.loading = true;
            //let reponse = await Ajax.get('/api/services/app/' + (context.state as any).entity + '/GetAll', { params: payload.data });
            //context.state.loading = false;
            //let page = reponse.data.result as PageResult<U>;
            //context.state.totalCount = page.totalCount;
            //context.state.list = page.items;
        },
        async create(context: ActionContext<GeneralTypeValueState, any>, payload: any) {
            context.state.loading = true;
            payload.data.type_id = context.state.gtype;
            let response = await Ajax.post('/api/type-values', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.list.push(response.data.result);
            let item = response.data.result;
            item.type = item.type.code;
            Util.abp.list.addItem(item);
            return response.data.result;
        },
        async update(context: ActionContext<GeneralTypeValueState, any>, payload: any) {
            context.state.loading = true;
            payload.data.type_id = context.state.gtype;
            let response = await Ajax.put('/api/type-values/' + payload.data.id, payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return response.data.result;
        },
        async delete(context: ActionContext<GeneralTypeValueState, any>, payload: any) {
            context.state.loading = true;
            let id = payload.data.id;
            await Ajax.delete('/api/type-values/' + id).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            let index = -1;
            context.state.list.forEach((item, i) => {
                if (item.id == id) index = i;
            });
            context.state.list.splice(index, 1);
            Util.abp.list.deleteItem(id);
        },
        async get(context: ActionContext<GeneralTypeValueState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/type-values/get/' + payload.id);
            context.state.loading = false;
            return reponse.data.result as GeneralTypeValue;
        }
    };
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        setList(state: GeneralTypeValueState, type: GeneralType) {
            state.list = [];
            state.totalCount = 0;
            state.gtype = null;
            if (type != null) {
                state.list = type.values;
                state.gtype = type.id;
                state.totalCount = type.values.length;
            }
        }
    });
}
const generaltypevalueModule=new GeneralTypeValueModule();
export default generaltypevalueModule;